import { getEventVariables } from '../actions/commandContext.js';
import { getObjectSchema } from '../Hasp/properties/v2/wireFormat.js';
import { gpioEditorSource } from './gpioLogic.js';
import { findNode, getEventSourceRef, getRootEvents, getSubjectWire } from './logicGraph.js';

// Readable properties of an object or GPIO entity a condition can compare.
const OBJECT_PROPERTIES = ['val', 'text'];
const GPIO_PROPERTIES = ['state', 'brightness', 'value'];

/**
 * What a condition or switch compares: `{ kind: 'event' }`, `{ kind: 'gpio',
 * node }` or `{ kind: 'object', object }`, with the wire for a wired subject.
 */
export function getFlowSubject(graph, nodeId, context = {}) {
    const wire = getSubjectWire(graph, nodeId);
    if (wire?.from.node !== undefined) return { kind: 'gpio', node: findNode(graph, wire.from.node), wire };
    if (wire?.from.object !== undefined) return { kind: 'object', object: context.getObject?.(wire.from.object) ?? null, wire };
    return { kind: 'event' };
}

/**
 * Properties a condition or switch can compare. For the event value: the
 * payload fields every event running the node provides (`val`, `text`, …).
 */
export function getSubjectPropertyChoices(graph, nodeId, context = {}, page = null) {
    const subject = getFlowSubject(graph, nodeId, context);
    if (subject.kind === 'gpio') {
        const entity = context.getGpioEntity?.(subject.node?.data?.entity);
        const advertised = Object.keys(entity?.properties ?? {});
        return entity ? GPIO_PROPERTIES.filter(property => advertised.includes(property)) : [...GPIO_PROPERTIES];
    }
    if (subject.kind === 'object') {
        const schema = subject.object?.schemaV2 ?? getObjectSchema(subject.object?.obj);
        return OBJECT_PROPERTIES.filter(property => Object.hasOwn(schema?.properties ?? {}, property));
    }
    const payloads = getRootEvents(graph, nodeId).map(event => {
        const ref = getEventSourceRef(graph, event.id);
        const gpio = ref?.node !== undefined ? findNode(graph, ref.node) : null;
        const source = gpio ? gpioEditorSource(page, gpio) : ref?.object !== undefined ? context.getObject?.(ref.object) : null;
        return source && event.data?.event ? getEventVariables(source, event.data.event) : [];
    });
    if (payloads.length === 0) return ['val'];
    return payloads.reduce((shared, payload) => shared.filter(property => payload.includes(property)));
}
